export default __webpack_public_path__ + "static/media/favicon-16x16.d882f3ea.png";